import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { ToastService } from '@ui-lib/components';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { ExceptionInterceptor } from './core/interceptors/exception.interceptor';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthConfigService } from './core/services/auth/auth-config.service';
import { LocalStorageService } from './core/services/storage/local-storage.service';
import { BffAdminApiConfiguration, BffAdminApiModule } from './core/openapi/bff-admin-api';
import { environment } from '../environments/environment';
import { IdentityApiConfiguration, IdentityApiModule } from './core/openapi/identity';
import { registerLocaleData } from '@angular/common';
import localeRu from '@angular/common/locales/ru';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { Chart } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';

export function HttpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(httpClient, 'assets/i18n/', '.json');
}

registerLocaleData(localeRu, 'ru-RU');

Chart.register(zoomPlugin);

export const appConfig: ApplicationConfig = {
  providers: [
    provideCharts(withDefaultRegisterables()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom([
      TranslateModule.forRoot({
        defaultLanguage: 'ru',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
      BffAdminApiModule.forRoot(() => {
        return new BffAdminApiConfiguration({
          basePath: environment.apiUrls.bffAdmin,
        });
      }),
      IdentityApiModule.forRoot(() => {
        return new IdentityApiConfiguration({
          basePath: environment.apiUrls.identity,
        });
      }),
    ]),
    provideRouter(appRoutes),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ExceptionInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    LocalStorageService,
    AuthConfigService,
    ToastService,
    {
      provide: LOCALE_ID,
      useValue: 'ru-RU',
    },
    provideAppInitializer(() => inject(AuthConfigService).configureOAuth()),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideOAuthClient(),
    { provide: OAuthStorage, useValue: localStorage },
  ],
};
